export default "__VITE_ASSET__FKuQVXbB__"